import { useRef } from 'react';
import { WidgetContainer } from '@/components/analytics/WidgetContainer';
import { LineChart } from '@/components/analytics/charts/LineChart';
import { useChartDimensions } from '@/hooks/useChartDimensions';
import type { ImprovementTrendData } from '@/types/analytics';
import styles from './ImprovementTrends.module.scss';

export interface ImprovementTrendsProps {
  data: ImprovementTrendData[] | null;
  isLoading?: boolean;
  error?: Error | null;
}

export function ImprovementTrends({ data, isLoading, error }: ImprovementTrendsProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const { width, height } = useChartDimensions(containerRef as any);

  const isEmpty = !data || data.length === 0;

  const chartSeries = data
    ? [
      {
        name: 'Success Rate',
        data: data.map((d) => ({ x: (d.date || '') as string, y: d.successRate })),
        color: 'var(--primary)',
      },
      {
        name: 'Avg Score',
        data: data.map((d) => ({ x: (d.date || '') as string, y: d.averageScore })),
        color: 'var(--success)',
      },
    ]
    : [];

  return (
    <WidgetContainer
      title="Improvement Trends"
      description="Performance over time"
      isLoading={isLoading}
      error={error}
      isEmpty={isEmpty}
      size="medium"
    >
      <div ref={containerRef} className={styles.improvementTrends}>
        {width > 0 && height > 0 && (
          <LineChart
            series={chartSeries}
            width={width}
            height={height}
            showDots
            showGrid
            animate
          />
        )}
      </div>
    </WidgetContainer>
  );
}
